<template>
  <header class="page-title">
    <h1>
      <slot/>
    </h1>
  </header>
</template>

<script>
export default {
  name: 'PageTitle',
};
</script>

<style lang="scss" scoped>
  .page-title {
    width: 100%;

    padding: 1.5rem;
    text-align: center;

    background-color: #e9e7e2;
    box-shadow: inset 0 0 7px 1px rgba(0, 0, 0, 0.25);

    transition: box-shadow 450ms ease-in-out;

    h1 {
      font-size: 1.75rem;
      font-family: "Sitka Heading", serif;
      margin: 0;

      user-select: none;
    }
  }

  .menu-open {
    .page-title {
      box-shadow: inset 7px 0 7px 1px rgba(0, 0, 0, 0.25);;
    }
  }
</style>
